module.exports = __webpack_public_path__ + "img/home-3.0fdb4062.webp";